var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSignUpIconUiSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 60 60"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 617",
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#a6ce39"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.015 36.017l17-17a2.251 2.251 0 011.648-.694 2.251 2.251 0 011.648.694 2.251 2.251 0 01.694 1.648 2.251 2.251 0 01-.694 1.648L26.648 40.976a2.23 2.23 0 01-1.628.694 2.23 2.23 0 01-1.628-.694l-8.71-8.71a2.185 2.185 0 01-.675-1.648 2.322 2.322 0 01.714-1.648 2.251 2.251 0 011.648-.694 2.251 2.251 0 011.648.694z",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/sign-up-icon-ui-success.74fcb74d5f17e599903065906dbe99c3.svg";
export { SvgSignUpIconUiSuccess as ReactComponent };